import { render } from "./MusicPanel.vue?vue&type=template&id=28579586"
import script from "./MusicPanel.vue?vue&type=script&lang=js"
export * from "./MusicPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__